module.exports = __webpack_public_path__ + "static/CSF0-95d811dec066fee8e80078c76200af31.png";